import * as React from "react";

type ContextType = {
  disableAll: boolean;
};

const Context = React.createContext<ContextType>({ disableAll: false });
export const useTooltipContext = () => React.useContext(Context);

export default Context;
